import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CONTACT } from "@/data/content";
import { EmailWithCopy } from "@/components/site/ContactFormDialog";

export default function ConditionsPage() {
  return (
    <div data-testid="conditions-page" className="min-h-screen bg-[#FBF7EF] text-[#2E2A22]" style={{ fontFamily: "Manrope, sans-serif" }}>
      <header className="mx-auto flex max-w-3xl items-center justify-between px-6 py-5">
        <Link to="/" data-testid="conditions-back-home" className="inline-flex items-center gap-2 text-sm font-semibold text-[#A66E08] hover:underline">
          <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
        </Link>
        <img src="/logo-tpoz.png" alt="T'POZ" className="h-14 w-auto" />
      </header>

      <main className="mx-auto max-w-3xl px-6 pb-20">
        <h1 data-testid="conditions-title" className="font-serif text-4xl sm:text-5xl leading-[1.1]">
          Conditions d'utilisation de <em className="text-[#A66E08]">T'POZ</em>
        </h1>
        <div className="mt-8 space-y-6 text-sm leading-relaxed text-[#2E2A22]/85">
          <section className="rounded-2xl bg-white border border-[#2E2A22]/8 p-6">
            <h2 className="font-serif text-xl">Le dispositif</h2>
            <p className="mt-2 text-[#6B6355]">
              T'POZ est une initiative solidaire de l'association Plus Belle La Vie 971. Elle propose
              aux femmes traversant un moment de vie exigeant des temps de répit et de ressourcement
              auprès de partenaires en Guadeloupe. Chaque bénéficiaire peut obtenir jusqu'à
              3 codes T'POZ sur 12 mois glissants.
            </p>
          </section>
          <section className="rounded-2xl bg-white border border-[#2E2A22]/8 p-6">
            <h2 className="font-serif text-xl">Demandes et codes</h2>
            <p className="mt-2 text-[#6B6355]" data-testid="conditions-refus">
              Chaque demande de code est examinée par l'association avant validation. T'POZ peut
              refuser une demande ou annuler un code en cas d'utilisation contraire à l'esprit du
              dispositif.
            </p>
            <p className="mt-2 text-[#6B6355]">
              Le code T'POZ est personnel. Il est communiqué par e-mail après validation et permet de
              réserver directement auprès du partenaire en bénéficiant de l'avantage T'POZ.
            </p>
          </section>
          <section className="rounded-2xl bg-white border border-[#2E2A22]/8 p-6">
            <h2 className="font-serif text-xl">Santé et responsabilité</h2>
            <p className="mt-2 text-[#6B6355]" data-testid="conditions-sante">
              Chaque participante atteste ne présenter aucune contre-indication médicale aux
              activités choisies. Le partenaire peut demander des informations complémentaires avant
              la prestation. T'POZ met en relation et n'est pas responsable de la réalisation des
              prestations.
            </p>
          </section>
          <section className="rounded-2xl bg-white border border-[#2E2A22]/8 p-6">
            <h2 className="font-serif text-xl">Contact</h2>
            <p className="mt-2 text-[#6B6355]">
              Pour toute question :{" "}
              <EmailWithCopy testId="conditions-email" className="font-semibold text-[#A66E08]" />
              {" "}· <a href={CONTACT.phoneHref} className="font-semibold text-[#A66E08] underline underline-offset-2">{CONTACT.phone}</a>
            </p>
            <p className="mt-2 text-[#6B6355]">
              Voir aussi :{" "}
              <Link to="/mentions-legales" className="font-semibold text-[#A66E08] underline underline-offset-2">
                Mentions légales &amp; confidentialité
              </Link>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
